import React, { useState } from 'react';
import { Button, Collapse, Input, Space, Typography } from 'antd';

import { useCabinetStore, useQuoteStore } from 'store';

export const Misc: React.FC = () => {
    const [toSetCabinetsValue, updateToSetCabinetsValue] = useState<string>('');
    const [toSetQuoteValue, updateToSetQuoteValue] = useState<string>('');
    const { cabinets, setCabinets, resetCabinets } = useCabinetStore((state) => state);
    const { quote, setQuote } = useQuoteStore((state) => state);

    return (
        <React.Fragment>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Typography.Title level={3}>Miscellaneous</Typography.Title>
                <Typography.Text>Import and export the data.</Typography.Text>
            </div>

            <Collapse
                defaultActiveKey={['cabinets']}
                items={[
                    {
                        key: 'cabinets', label: 'Cabinets',
                        children: (
                            <React.Fragment>
                                <div>
                                    <Typography.Title level={4}>Import</Typography.Title>
                                    <Typography.Text>Import JSON to set the cabinets.</Typography.Text>

                                    <Input.TextArea rows={10} onChange={(v) => updateToSetCabinetsValue(v.target.value)} />
                                    <Space>
                                        <Button onClick={() => setCabinets(JSON.parse(toSetCabinetsValue))}>Set Cabinets</Button>
                                        <Button onClick={() => resetCabinets()}>Clear Cabinets</Button>
                                    </Space>
                                </div>

                                <div>
                                    <Typography.Title level={4}>Export</Typography.Title>
                                    <Typography.Text>Export the cabinets as JSON.</Typography.Text><br />

                                    <Typography.Text code copyable>{ JSON.stringify(cabinets) }</Typography.Text>
                                </div>
                            </React.Fragment>
                        ),
                    },
                    {
                        key: 'quote', label: 'Quote Details',
                        children: (
                            <React.Fragment>
                                <div>
                                    <Typography.Title level={4}>Import</Typography.Title>
                                    <Typography.Text>Import JSON to set the quote details.</Typography.Text>

                                    <Input.TextArea rows={10} onChange={(v) => updateToSetQuoteValue(v.target.value)} />
                                    <Button onClick={() => setQuote(JSON.parse(toSetQuoteValue))}>Set Quote Details</Button>
                                </div>

                                <div>
                                    <Typography.Title level={4}>Export</Typography.Title>
                                    <Typography.Text>Export the quote details as JSON.</Typography.Text><br />

                                    <Typography.Text code copyable>{ JSON.stringify(quote) }</Typography.Text>
                                </div>
                            </React.Fragment>
                        ),
                    },
                ]}
            />

        </React.Fragment>
    );
};
